export const DISTANCES_KM = [1, 10, 25, 50, 100];
export const DISTANCES_MILES = [1, 5, 10, 30, 50];
export const CUSTOM_DISTANCES_LIMIT = 10;
export const DEFAULT_DISTANCE_KM = 50;
export const DEFAULT_DISTANCE_MILES = 30;
